import React from "react";
import "./footer.scss";
import clsx from "clsx";

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();
    const isSocial = window.location.pathname.includes("/social/");

    return (
        <footer
            className={clsx("footer text-center mx-auto", {
                "!tw-z-[999] tw-bg-white tw-flex tw-justify-center tw-justify-items-center tw-justify-self-center tw-w-screen md:tw-w-[600px]":
                    isSocial,
            })}
        >
            <div
                className={clsx("container", {
                    "tw-flex tw-flex-col tw-justify-center tw-items-center": isSocial,
                })}
            >
                <div className="d-flex gap-2 flex-wrap mb-1">
                    <div className="about-us">
                        <span className="text-muted">
                            <a href="/about">About Us</a>
                        </span>
                    </div>

                    <div className="contact-us">
                        <span className="text-muted">
                            <a href="/contact">Contact Us</a>
                        </span>
                    </div>

                    <div className="privacy-policy">
                        <span className="text-muted">
                            <a href="/privacy-policy">Privacy Policy</a>
                        </span>
                    </div>

                    <div className="terms-of-service">
                        <span className="text-muted">
                            <a href="/terms-of-service">Terms of Service</a>
                        </span>
                    </div>

                    <div className="terms-of-service">
                        <span className="text-muted">
                            <a href="/credits">Credits</a>
                        </span>
                    </div>

                    <div className="sitemap">
                        <span className="text-muted">
                            <a href="/sitemap">Sitemap</a>
                        </span>
                    </div>
                </div>

                <div>
                    <div>
                        <span className="text-muted ps-2">© PriceMe {currentYear}. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
